import composeFetchSaga from '../dom/composeFetchSaga'
export default composeFetchSaga
